/**
 * @generated SignedSource<<ab771d6d7f14313f1bf27206756b3ede>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef$data = {
  readonly __id: string;
  readonly " $fragmentType": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef";
};
export type context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef$key = {
  readonly " $data"?: context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "context_nativeIssueTable_IFCConfigContextProvider_columnsQueryRef",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "da9cc8f15ae8ed9e7e4b651383cc3495";

export default node;
